module.exports = __webpack_public_path__ + "media/src/images/icons/magnifying_glass-d19f9a16f98627b7f99e6337e136ea41.svg";